import axios from 'axios';
import { TREATMENTS } from '../data/treatments';

const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Build the catalog of treatment options shared with the AI concierge.
 * Mirrors slug → name → starting_price so the LLM can choose from the
 * full 46-treatment catalogue instead of the backend's 8 defaults.
 */
const buildTreatmentOptions = () =>
  TREATMENTS.map((t) => ({
    slug: t.slug,
    name: t.name,
    starting_price: t.startingPrice || '',
  }));

/**
 * Calls our local FastAPI /api/recommend backed by Claude Sonnet via the
 * Emergent universal LLM key. Returns the parsed recommendation.
 */
export const getAIRecommendation = ({ description, city, budget, sessionId } = {}) => {
  return axios.post(`${BASE}/api/recommend`, {
    description,
    city,
    budget,
    session_id: sessionId,
    treatment_options: buildTreatmentOptions(),
  }).then((res) => res.data);
};
